"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogMessageType = void 0;
var LogMessageType;
(function (LogMessageType) {
    LogMessageType[LogMessageType["DEFAULT"] = 0] = "DEFAULT";
    LogMessageType[LogMessageType["NEW_GENERATION"] = 1] = "NEW_GENERATION";
})(LogMessageType || (exports.LogMessageType = LogMessageType = {}));
